// extracted by mini-css-extract-plugin
var _1 = "vdz6r";
var _2 = "f7fBV";
export { _1 as "list", _2 as "ranges" }
